export default __webpack_public_path__ + "static/media/confirmation-animation.248ba76f.svg";